/**
 * @file: SearchBookmarksManager.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { asyncStorageSubjectForKey$ } from '@euler/functions/useAsyncStorage';
import { SearchCriteria } from './search-criteria/types';
import { buildSearchCriteriaBookmark } from './search-criteria/utils';

export class SearchBookmarksManager {
  static readonly shared = new SearchBookmarksManager();

  readonly searchBookmarks$ = asyncStorageSubjectForKey$<SearchCriteria[]>(
    'search-bookmarks',
    undefined,
    { storageType: 'file' },
  );

  searchCriteriaBookmarkPredictByKey(key: string) {
    return (entry: SearchCriteria) => {
      const bookmark = buildSearchCriteriaBookmark(entry);
      return bookmark.key === key;
    };
  }

  async saveSearchCriterionAsBookmark(criteria: SearchCriteria) {
    const saved = [...(this.searchBookmarks$.getValue() ?? [])];
    const { key } = buildSearchCriteriaBookmark(criteria);
    if (saved.some(this.searchCriteriaBookmarkPredictByKey(key))) {
      return;
    }
    saved.push(criteria);
    this.searchBookmarks$.next(saved);
  }

  async removeSearchCriteriaBookmarkByKey(key: string) {
    const saved = [...(this.searchBookmarks$.getValue() ?? [])];
    const index = saved.findIndex(this.searchCriteriaBookmarkPredictByKey(key));
    if (index >= 0) {
      saved.splice(index, 1);
      this.searchBookmarks$.next(saved);
    }
  }
}
